import React, { useState, useCallback, useEffect } from "react";

import { Dropdown } from "react-bootstrap";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { useDocumentData } from "react-firebase-hooks/firestore";
import ModifyProfil from "./modifyProfil";
import Post from "../post";
import NewPost from "./newPost";
import Avatar from "react-avatar";
import { useRouteMatch } from "react-router-dom";
import IdPlayer from "./idPlayer";
import AddIdPlayer from "./addIdPlayer";

const Profil = (props) => {
  let url = useRouteMatch();
  const [valueUserInfo] = useDocumentData(
    firebase.firestore().doc(`users/${url.params.id}`)
  );

  const [myProfil, setMyProfil] = useState(false);
  const [modifyTrigger, setModifyTrigger] = useState(false);
  const [addPlayerIdTrigger, setAddPlayerIdTrigger] = useState(false);

  useEffect(() => {
    if (url.params.id === props.userId) {
      setMyProfil(true);
    }
  }, [props.userId, url.params.id]);

  const updateInfoPlayer = useCallback(
    (favType, favTab) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(valueUserInfo.id)
        .update({
          [favType]: favTab,
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    },
    [valueUserInfo]
  );

  let genresPopTab = ["MMORPG", "FPS", "Horreur", "Esport"];
  let gamesPopTab = ["The legend of Zelda", "Minecraft", "World of Warcraft"];
  let consolesPopTab = ["PC", "PS4", "Xbox One", "Switch"];

  const [addGenreInput, setAddGenreInput] = useState();
  const [addGameInput, setAddGameInput] = useState();
  const [addConsoleInput, setAddConsoleInput] = useState();

  const addFavSubmit = useCallback(
    (e, favVal, favType) => {
      e.preventDefault();
      let favTab;
      if (valueUserInfo[favType]) {
        favTab = valueUserInfo[favType];
        favTab.push(favVal);
      } else {
        favTab = [favVal];
      }

      updateInfoPlayer(favType, favTab);
    },
    [valueUserInfo, updateInfoPlayer]
  );

  const deleteFav = useCallback(
    (key, favType) => {
      let favTab = valueUserInfo[favType];
      favTab.splice(key, 1);

      updateInfoPlayer(favType, favTab);
    },
    [valueUserInfo, updateInfoPlayer]
  );

  const [newPostTrigger, setNewPostTrigger] = useState(false);
  const [postValue, setPostValue] = useState();

  const newPostToggle = useCallback(() => {
    setNewPostTrigger(true);
    setPostValue("");
  }, []);

  return (
    <>
      {valueUserInfo && (
        <>
          <section className="personnal">
            <div className="container  ">
              <div className="personnal__content">
                {!modifyTrigger ? (
                  <>
                    <Avatar
                      className="personnal__avatar"
                      name={valueUserInfo.pseudo}
                      round="100%"
                      bsRole="toggle"
                    />
                    <h2>{valueUserInfo.pseudo && valueUserInfo.pseudo}</h2>
                    <p>{valueUserInfo.bio && valueUserInfo.bio}</p>
                    {myProfil && (
                      <button
                        onClick={() => setModifyTrigger(true)}
                        className="personnal__modify"
                      >
                        Modifier
                      </button>
                    )}
                  </>
                ) : (
                  <ModifyProfil
                    valueUserInfo={valueUserInfo}
                    setModifyTrigger={setModifyTrigger}
                  />
                )}
              </div>
            </div>
          </section>

          <section className="container myProfil ">
            <div className="myProfil__colLeft  posts">
              <h2 className="myProfil__title">Annonces</h2>
              {myProfil && (
                <button
                  onClick={() => newPostToggle()}
                  className="posts__btnNew"
                >
                  Créer une annonce
                </button>
              )}

              {valueUserInfo && valueUserInfo.posts.length > 0 ? (
                <ul>
                  {valueUserInfo.posts.map((postId, key) => (
                    <Post
                      key={key}
                      postId={postId}
                      setNewPostTrigger={setNewPostTrigger}
                      setPostValue={setPostValue}
                      valueUserInfo={valueUserInfo}
                      userId={props.userId}
                      searchBool={myProfil ? false : true}
                    />
                  ))}
                </ul>
              ) : (
                <p>Il n'y a rien ici.</p>
              )}
            </div>
            {newPostTrigger && (
              <NewPost
                valueUserInfo={valueUserInfo}
                userId={props.userId}
                setNewPostTrigger={setNewPostTrigger}
                postValue={postValue}
              />
            )}
            <div className="myProfil__colRight">
              <h2 className="myProfil__title">Infos joueur</h2>
              <div className="infoPlayer">
                <div className="topList">
                  <h3 className="topList__title">Genres favoris</h3>
                  <ul className="topList__list">
                    {valueUserInfo.genres_fav &&
                      valueUserInfo.genres_fav.map((val, key) => (
                        <li
                          onClick={() =>
                            myProfil && deleteFav(key, "genres_fav")
                          }
                          key={key}
                          className="topList__el"
                        >
                          {val}
                        </li>
                      ))}
                    {myProfil && (
                      <li className="topList__btnAdd">
                        <Dropdown>
                          <Dropdown.Toggle drop="up">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              className="svg-inline--fa fa-plus fa-w-14  "
                              data-icon="plus"
                              data-prefix="fas"
                              viewBox="0 0 448 512"
                            >
                              <path
                                fill="currentColor"
                                d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                              ></path>
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <form
                              onSubmit={(e) =>
                                addFavSubmit(e, addGenreInput, "genres_fav")
                              }
                            >
                              <label>Ajouter un genre</label>
                              <input
                                as="input"
                                type="text"
                                placeholder="FPS, Horreur,..."
                                autoFocus
                                onChange={(e) =>
                                  setAddGenreInput(e.target.value)
                                }
                              />
                            </form>
                            <Dropdown.Divider />
                            <Dropdown.Header>Genres populaire</Dropdown.Header>
                            <ul>
                              {genresPopTab.map((genreVal, key) => {
                                let boolean = false;
                                if (valueUserInfo.genres_fav) {
                                  valueUserInfo.genres_fav.forEach((el) => {
                                    if (el === genreVal) {
                                      boolean = true;
                                    }
                                  });
                                }
                                if (!boolean) {
                                  return (
                                    <Dropdown.Item
                                      onClick={(e) =>
                                        addFavSubmit(e, genreVal, "genres_fav")
                                      }
                                      as="li"
                                      key={key}
                                    >
                                      {genreVal}
                                    </Dropdown.Item>
                                  );
                                }
                                return <li key={key} className="hidden"></li>;
                              })}
                            </ul>
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="topList">
                  <h3 className="topList__title">Jeux favoris</h3>
                  <ul className="topList__list">
                    {valueUserInfo.games_fav &&
                      valueUserInfo.games_fav.map((val, key) => (
                        <li
                          onClick={() =>
                            myProfil && deleteFav(key, "games_fav")
                          }
                          key={key}
                          className="topList__el"
                        >
                          {val}
                        </li>
                      ))}
                    {myProfil && (
                      <li className="topList__btnAdd">
                        <Dropdown>
                          <Dropdown.Toggle drop="up">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              className="svg-inline--fa fa-plus fa-w-14  "
                              data-icon="plus"
                              data-prefix="fas"
                              viewBox="0 0 448 512"
                            >
                              <path
                                fill="currentColor"
                                d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                              ></path>
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <form
                              onSubmit={(e) =>
                                addFavSubmit(e, addGameInput, "games_fav")
                              }
                            >
                              <label>Ajouter un jeu</label>
                              <input
                                as="input"
                                type="text"
                                placeholder="Minecraft, CSGO, ..."
                                autoFocus
                                onChange={(e) =>
                                  setAddGameInput(e.target.value)
                                }
                              />
                            </form>
                            <Dropdown.Divider />
                            <Dropdown.Header>Jeux populaire</Dropdown.Header>
                            <ul>
                              {gamesPopTab.map((val, key) => {
                                let boolean = false;
                                if (valueUserInfo.games_fav) {
                                  valueUserInfo.games_fav.forEach((el) => {
                                    if (el === val) {
                                      boolean = true;
                                    }
                                  });
                                }
                                if (!boolean) {
                                  return (
                                    <Dropdown.Item
                                      onClick={(e) =>
                                        addFavSubmit(e, val, "games_fav")
                                      }
                                      as="li"
                                      key={key}
                                    >
                                      {val}
                                    </Dropdown.Item>
                                  );
                                }
                                return <li key={key} className="hidden"></li>;
                              })}
                            </ul>
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="topList">
                  <h3 className="topList__title">Consoles</h3>
                  <ul className="topList__list">
                    {valueUserInfo.consoles &&
                      valueUserInfo.consoles.map((val, key) => (
                        <li
                          onClick={() => myProfil && deleteFav(key, "consoles")}
                          key={key}
                          className="topList__el"
                        >
                          {val}
                        </li>
                      ))}
                    {myProfil && (
                      <li className="topList__btnAdd">
                        <Dropdown>
                          <Dropdown.Toggle drop="up">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              className="svg-inline--fa fa-plus fa-w-14  "
                              data-icon="plus"
                              data-prefix="fas"
                              viewBox="0 0 448 512"
                            >
                              <path
                                fill="currentColor"
                                d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                              ></path>
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <form
                              onSubmit={(e) =>
                                addFavSubmit(e, addConsoleInput, "consoles")
                              }
                            >
                              <label>Ajouter une console</label>
                              <input
                                as="input"
                                type="text"
                                placeholder="PC, PS4,..."
                                autoFocus
                                onChange={(e) =>
                                  setAddConsoleInput(e.target.value)
                                }
                              />
                            </form>
                            <Dropdown.Divider />
                            <Dropdown.Header>
                              Consoles populaire
                            </Dropdown.Header>
                            <ul>
                              {consolesPopTab.map((val, key) => {
                                let boolean = false;
                                if (valueUserInfo.consoles) {
                                  valueUserInfo.consoles.forEach((el) => {
                                    if (el === val) {
                                      boolean = true;
                                    }
                                  });
                                }
                                if (!boolean) {
                                  return (
                                    <Dropdown.Item
                                      onClick={(e) =>
                                        addFavSubmit(e, val, "consoles")
                                      }
                                      as="li"
                                      key={key}
                                    >
                                      {val}
                                    </Dropdown.Item>
                                  );
                                }
                                return <li key={key} className="hidden"></li>;
                              })}
                            </ul>
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              <div className="idPlayer">
                <h2 className="myProfil__title">ID Joueur</h2>
                <ul className="idPlayer__list">
                  {valueUserInfo.player_ids &&
                    valueUserInfo.player_ids.map((el, key) => (
                      <IdPlayer
                        myProfil={myProfil}
                        key={key}
                        idInfo={el}
                        player_ids={valueUserInfo.player_ids}
                        userId={props.userId}
                      />
                    ))}
                </ul>
                {myProfil && !addPlayerIdTrigger && (
                  <button
                    onClick={() => setAddPlayerIdTrigger(true)}
                    className="idPlayer__add"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      className="svg-inline--fa fa-plus fa-w-14  "
                      data-icon="plus"
                      data-prefix="fas"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="currentColor"
                        d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                      ></path>
                    </svg>
                    Ajouter
                  </button>
                )}
                {addPlayerIdTrigger && (
                  <AddIdPlayer
                    player_ids={valueUserInfo.player_ids}
                    userId={props.userId}
                    setAddPlayerIdTrigger={setAddPlayerIdTrigger}
                  />
                )}
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Profil;
